<template>
  <div>
    <div>
      <el-carousel trigger="hover" height="800px" :interval="12000">
        <el-carousel-item v-for="(item, bannarDesc) in imgList" :key="bannarDesc">
          <img v-bind:src="api + item.bannarUrl"/>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="lowerbox">
      <div class="mlbox">
        <div><a style="color:#008D40 ">新建建筑工程用胶粘剂</a> 产品世界</div>
        <div class="pctitle">The world of adhesive products for urban and rural construction</div>
      </div>
      <div class="cpb">
        <div class="cpbox1" v-for="(item,index) in listData1" :key="index" @click="openDetails(item,index,'name1')">
          <div class="cpsimg"><img :src="api + item.icon" class="cpimg" alt=""></div>
          <div class="cpname">
        <div class="titleName">{{item.menuName}} </div>
<!--            <div>{{ item.productName }}</div>-->
            <div class="detailbox">查看详情</div>
          </div>
        </div>
      </div>
    </div>
    <div class="lowerbox">
      <div class="mlbox">
        <div><a style="color:#008D40 ">建筑工程维修用胶粘剂</a> 产品世界</div>
        <div class="pctitle">The world of adhesive products for old city renovation</div>
      </div>
      <div class="cpb">
        <div class="cpbox1" v-for="(item,index) in listData2" :key="index" @click="openDetails(item,index,'name2')">
          <div class="cpsimg"><img :src="api + item.icon" class="cpimg" alt=""></div>
          <div class="cpname">
            <div class="titleName">{{item.menuName}} </div>
            <!--            <div>{{ item.productName }}</div>-->
            <div class="detailbox">查看详情</div>
          </div>
        </div>
      </div>
    </div>
<!-- 新闻中心 -->
<div class="lowerbox widthbox">
   <div class="mlbox">
        <div>新闻中心</div>
        <div class="pctitle">NEWS CENTER</div>
      </div>
      <div class="flexsbox">
        <div style="width: 100%;min-height: 500px">
          <div class="flexsbox">
            <div class="tabbox">
              <div :class="{'active':active_btn==index}" v-for="(item,index) in newsList1" :key="index"
                   @click="newsDetails(index,item)">{{item.menuName}}
              </div>
            </div>
          </div>
          <div class="newtext">
          <div class="newbox" v-for="(item,childIndex) in newsTitle" :key="childIndex">
            <div class="newtitle" @click="menuList(item,item.menuId,item,childIndex)"><span class="spot">·</span>{{ item.menuName }}</div>
          </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 建筑百科 -->
     <div class="lowerbox widthbox">
        <div class="mlbox">
        <div>建筑百科</div>
        <div class="pctitle">Architectural Encyclopedia</div>
      </div>
      <div class="flexsbox">
        <div style="width: 100%;min-height: 500px">
          <div class="flexsbox">
            <div class="tabbox">
              <div :class="{'active':active_btn==index}" v-for="(item,index) in baikeList" :key="index"
                   @click="baikeDetails(index,item)">{{item.menuName}}
              </div>
            </div>
          </div>
          <div class="newtext">
          <div class="newbox" v-for="(item,childIndex) in baikeTitle" :key="childIndex">
            <div class="newtitle" @click="menuList(item,item.menuId,item,childIndex)"><span class="spot">·</span>{{ item.menuName }}</div>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lowerbox">
      <div class="mlbox">
        <div>企业中心</div>
        <div class="pctitle">ENTERPRISE CENTER</div>
      </div>
      <div class="jsbox" @click="opensl()">
<!--        <div class="imgbox"></div>
        <div class="introduce">
          <div class="cenbox">湖南神力胶业集团</div>
          <div class="textbox">创建于1989年，专业从事有机高分子化合胶粘剂研发/生产/贸易于一体的企业，主要生产石材胶和其他粘胶剂</div>
          <div class="textbox">
            湖南神力胶业集团创建于1989年11月，是一家专业从事有机高分子化合胶粘剂研发、生产、贸易于一体且具有全部自主知识产权的企业。总部座落在长沙国家生物医药园(浏阳工业园)。紧靠319国道，东距长沙市36公里，离长沙市黄花国际机场20公里。公司占地面积19800平方米，地处长浏、岳汝、昌平、浏大四条高速公路交界处，长、株、潭城际轻轨贯穿全境，交通便利。优美的自然环境、便捷的交通环境、高速发展的人文科技环境，孕育出了这家蓝色、漂亮、齐整的现代化企业。神力荣耀成为世界花炮之都浏阳又一崭新的名片。
          </div>
          <div class="more" @click="opensl()">了解更多</div>
        </div>-->
      </div>
    </div>
    <div class="lowerbox">
      <div class="mlbox">
        <div>董事长寄语</div>
        <div class="pctitle">Chairman message</div>
      </div>
      <div class="dszbox"> </div>
    </div>
    <!-- 致用户一封信 -->
    
    <div class="flexbox">
      <div class="flexImg"><img src="../../static/img/home1.png" alt=""></div>
      <div class="flexImg"><img src="../../static/img/home2.png" alt=""></div>
      <div class="flexImg"><img src="../../static/img/home3.png" alt=""></div>
    </div>
<!--    <div class="lowerbox widthbox">-->
<!--      <div class="mlbox">-->
<!--        <div>新闻中心</div>-->
<!--        <div class="pctitle">ENTERPRISE CENTER</div>-->
<!--      </div>-->
<!--      <div class="newsboxs">-->
<!--        <div class="newsbigbox">-->
<!--          <div>-->
<!--            <img src="../../static/img/img.jpg" alt="" style="width: 100%">-->
<!--          </div>-->
<!--          <div class="newbox1" @click="menuList(this.oneNewTitle,this.oneNewTitle.menuId,this.oneNewTitle,this.oneNewTitle.childIndex)">-->
<!--            {{oneNewTitle.menuName}}-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="newbox2" >-->
<!--          <div class="titlebox1" v-for="(item,childIndex) in newsTitle" :key="childIndex">-->
<!--              <div class="timebox">-->
<!--                <div class="daybox">{{ item.createTime.slice(8,10) }}</div>-->
<!--                <div class="nianbox">{{ item.createTime.slice(0,7) }}</div>-->
<!--              </div>-->
<!--            <div class="titles" @click="menuList(item,item.menuId,item,childIndex)">{{ item.menuName }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="lowerbox widthbox">
      <div class="flexsbox">
        <div style="width: 100%;min-height: 500px">
          <div class="flexsbox">
            <div class="newtit">
              <div>新闻中心</div>
              <div class="pctitle">NEWS CENTER</div>
            </div>
            <div class="tabbox">
              <div :class="{'active':active_btn==index}" v-for="(item,index) in newsList1" :key="index"
                   @click="newsDetails(index,item)">{{item.menuName}}
              </div>
            </div>
          </div>
          <div class="newDetail">
            <div>
              <img src="../../static/img/054fdf4d7b696fca412a802db1694c1.jpg" style="width: 100%; max-width: 550px " alt="">
            </div>
          </div>
          <div class="newtext">
          <div class="newbox" v-for="(item,childIndex) in newsTitle" :key="childIndex">
            <div class="newtitle" @click="menuList(item,item.menuId,item,childIndex)"><span class="spot">·</span>{{ item.menuName }}</div>
          </div>
          </div>
        </div>
      </div>
    </div>-->
  </div>
</template>
<script>
let api = 'https://www.slfangshuijiao.com/api';
let deptId = 111;
export default {
  name: 'Shouye',
  data() {
    return {
      newsTitle: [],
      oneNewTitle: [],
      newsList: [],
      newsList1: [],
      newsList2: [],
      active_btn: 0,
      activeName: 'first',
      imgList: [],
      listData1: [],
      listData2: [],
      //产品分页
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        type: '',
        gjz: '',
      },
      menuId:'',
      name1:'',
      name2:'',
      api: 'https://www.slfangshuijiao.com/api',
      deptId: 111,
      baikeList: [],
      baikeTitle: [],
      baikeActiveBtn: 0
    }
  },
  created() {

  },
  mounted() {
    this.lbList()
    this.newList()
    // this.zxSubmit()
  },
  methods: {
    //了解更多跳转
    opensl(){
      window.location = '/#/ejml?id=18&name=走进神力';
      document.documentElement.scrollTop = 0;
    },
    //打开文件
    openFile(item){
      window.open(api + item.target)
    },
    openUrl(item){
      if (item.menuType == 'D'){
        window.location = '/#/cplist?id=' + item.menuId + '&name=' + encodeURI(item.menuName) + '&menuId=' + item.menuId;
      }
    },
    //跳转产品详情页面
    openDetails(item,index,name) {
      if (name == 'name1'){
        name = this.name1
      }else {
        name = this.name2
      }
      let menuId = ''
      if (item.children && item.children[0]){
        menuId = item.children[0].menuId
      }else {
        menuId = item.menuId
      }
      // return
      window.location = "/#/cplist?id=" + this.menuId + '&name=产品世界'+ '&index=' + index+ '&titName=' + name + '&menuId=' + menuId
      // window.location = "/#/cpdetails?id=" + item.productId + '&name=' + encodeURI(item.productName)
    },
    newsDetails(index, items) {
      this.newsList1.forEach(item => {
        if (item.menuName == items.menuName) {
          this.newsTitle = item.children || []
        }
      })
      this.active_btn = index
    },
    
    // 建筑百科详情
    baikeDetails(index, items) {
      // 检查是否为虚拟分类
      if (items.menuId && typeof items.menuId === 'string' && items.menuId.startsWith('virtual_')) {
        // 对于虚拟分类，显示一个默认的消息或空内容
        this.baikeTitle = [{
          menuId: 'virtual_info_' + items.menuName,
          menuName: `关于 ${items.menuName} 的内容正在建设中...`,
          menuType: 'C',
          content: `有关${items.menuName}的详细信息将在后续更新中提供。`
        }];
      } else {
        this.baikeList.forEach(item => {
          if (item.menuName == items.menuName) {
            this.baikeTitle = item.children || []
          }
        })
      }
      this.baikeActiveBtn = index
    },
    handleClick(tab, event) {
    },
    //新闻列表
    async newList() {
      try {
        const response = await this.$api.site.getColumnList();
        const res = response.data;
        
        if (res.code == '0') {
          if (res.data) {
            this.newsList = this.handleTree(res.data, 'menuId', 'parentId')
         //   console.log(6666,this.newsList);
            //建筑用胶粘剂产品世界数据
            this.newsList.forEach(item=>{
              if (item.menuName == '产品世界'){
                if(item.children && item.children[0] && item.children[1]) {
                  this.listData1 = item.children[0].children
                  this.listData2 = item.children[1].children
                  this.menuId = item.menuId
                  this.name1 = item.children[0].menuName
                  this.name2 = item.children[1].menuName
                }
              }
            })
           // console.log('建筑用胶粘剂产品世界数据',this.listData1,this.listData2);
            var newArr1 = []
            var baikeArr = []
            this.newsList.forEach(item => {
              if (item.visible == 1){
                newArr1.push(item)
                // 如果是建筑百科相关的分类，单独提取
                if (item.menuName.includes('建筑') || item.menuName.includes('百科') || item.menuName.includes('建筑百科')) {
                  baikeArr.push(item)
                }
              }
            })
            
            // 检查是否已包含特定的建筑百科分类
            const requiredBaikeCategories = ['混凝土知识', '胶粘剂知识','裂纹与粘度', '权威发布', '腐蚀介质', '钢筋锈蚀危害','不倒塌知识', '打造千年工程', '告别修缮'];
            const existingBaikeCategories = [];
            
            // 首先查找已存在的相关分类
            baikeArr = newArr1.filter(item => 
              item.menuName.includes('建筑') || 
              item.menuName.includes('百科') || 
              item.menuName.includes('建筑百科') ||
              item.menuName.includes('技术') || 
              item.menuName.includes('知识') || 
              item.menuName.includes('介绍') ||
              item.menuName.includes('混凝土') ||
              item.menuName.includes('裂纹') ||
              item.menuName.includes('粘度') ||
              item.menuName.includes('权威发布') ||
              item.menuName.includes('腐蚀') ||
              item.menuName.includes('不倒塌') ||
              item.menuName.includes('千年工程') ||
              item.menuName.includes('修缮')
            );
            
            // 检查是否有需要的分类已经存在
            requiredBaikeCategories.forEach(category => {
              if (newArr1.some(item => item.menuName.includes(category))) {
                existingBaikeCategories.push(category);
              }
            });
            
            // 添加缺失的特定分类（如果后端没有提供这些分类，可以创建虚拟分类）
            requiredBaikeCategories.forEach(category => {
              if (!existingBaikeCategories.includes(category)) {
                // 创建一个虚拟的分类对象
                const virtualCategory = {
                  menuId: `virtual_${category}`,
                  menuName: category,
                  menuType: 'M', // 默认类型
                  children: [], // 暂无子项
                  visible: 1 // 可见
                };
                baikeArr.push(virtualCategory);
              }
            });
            
            // 如果没有找到任何建筑百科相关分类，则从所有分类中选择一些作为建筑百科
            if (baikeArr.length === 0 && newArr1.length > 0) {
              baikeArr = newArr1.slice(0, 3); // 取前3项作为建筑百科
            }
            
            this.newsList1 = newArr1
            this.baikeList = baikeArr
           // console.log(1111,newArr1)
            if (newArr1 && newArr1.length > 0 && newArr1[0] && newArr1[0].children) {
              if(newArr1[0].children[0]) {
                this.oneNewTitle = newArr1[0].children[0]
              }
              newArr1[0].children.forEach((item,index)=>{
                // if (index > 0 && index<5){
                  if(item.createTime) {
                    item.createTime = item.createTime.slice(0,10)
                  }
                  this.newsTitle.push(item)
                // }
              })
            }
            
            // 初始化建筑百科标题
            if (this.baikeList && this.baikeList.length > 0 && this.baikeList[0] && this.baikeList[0].children) {
              this.baikeTitle = this.baikeList[0].children || [];
            }
            //console.log('shuju',newArr1[0].children,this.newsTitle);
           // console.log('一条',this.oneNewTitle);
          }
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
       // console.error('获取新闻列表失败:', error);
        this.$message.error('获取数据失败');
      }
    },
    
    // 新增：获取轮播图列表
    async getBannerList() {
      try {
        const params = {
          bannarType: screen.width > 765 ? 1 : 2
        };
        const response = await this.$api.site.getBannarList(params);
        const res = response.data;
        
        if (res.code == '0') {
          if (res.data) {
            this.imgList = res.data;
          }
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        console.error('获取轮播图列表失败:', error);
        this.$message.error('获取轮播图失败');
      }
    },
    
    // 新增：全局搜索功能
    async globalSearch(keyword) {
      try {
        const response = await this.$api.site.globalSearch(keyword);
        const res = response.data;
        
        if (res.code == '0') {
          // 处理搜索结果
          console.log('搜索结果:', res.data);
          return res.data;
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        console.error('全局搜索失败:', error);
        this.$message.error('搜索失败');
      }
    },

    //二级跳转方法
    async menuList(item1, id, item2, index) {
      // 检查是否为虚拟分类
      if (id && typeof id === 'string' && id.startsWith('virtual_')) {
        // 对于虚拟分类，显示提示信息
        this.$message.info('该内容正在建设中，敬请期待');
        return;
      }
      
      // return
      try {
        const response = await this.$api.site.getColumnDetail(id);
        const res = response.data;
        if (res.code == '0') {
          if (item1.menuType === 'D') {
            window.open('/#/cplist?id=' + item2.menuId + '&name=' + encodeURI(item2.menuName) + '&index=' + index + '&menuId=' + item2.menuId)
          } else if (item1.menuType === 'C') {
            // console.log(111111,item1.target)
            if(item1.target != ''){
              window.open(api + item1.target)
            }
            // window.location = '/#/ejml?id=' + item2.menuId + '&name=' + encodeURI(item2.menuName) + '&target=' + item1.target + '&index=' + 0;
            // document.documentElement.scrollTop = 0;
            // window.location.reload();
          } else if (res.data && res.data.length > 0) {
            if (item1.menuType === 'F' && item1.perms == '') {
              this.$message('暂无数据');
              return
            } else if (item1.menuType === 'M' && item1.children == '') {
              this.$message('暂无数据');
              return
            } else if (item1.menuType === 'M') {
              window.open('/#/ejml?id=' + item2.menuId + '&name=' + encodeURI(item2.menuName) + '&index=' + 0);
              // document.documentElement.scrollTop = 0;
              // window.location.reload();
            } else if (item1.menuType === 'F') {
              window.open('/#/ejml?id=' + item2.menuId + '&name=' + encodeURI(item2.menuName) + '&index=' + 0) ;
              // document.documentElement.scrollTop = 0;
              // window.location.reload();
            }
          }
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        console.error('获取栏目详情失败:', error);
        this.$message.error('获取数据失败');
      }
    },

    // 轮播图列表
    async lbList() {
      try {
        const num = screen.width > 765 ? 1 : 2;
        const response = await this.$api.site.getBannarList({
          bannarType: num
        });
        const res = response.data;
        
        // console.log('轮播',res)
        if (res.code == '0') {
          if (res.data) {
            //console.log(res.data.data)
            this.imgList = res.data;
          }
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        console.error('获取轮播图失败:', error);
        this.$message.error('获取轮播图失败');
      }
    },
    //产品列表
    /*zxSubmit() {
      let that = this;
      that.$axios.post(api + '/site/productList', {
        columnId: 133,
        deptId:deptId,
        pageNum: this.queryParams.pageNum,
        pageSize: this.queryParams.pageSize,
        param: this.queryParams.gjz,

      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          if (res.data.data) {
            that.listData = res.data.data.rows
            console.log(22222222123,that.listData);
            that.listData.forEach(item => {
              item.productPhoto = item.productPhoto.split(',')
            })
            that.total = res.data.data.total
          }
        } else {
          that.$message.error(res.message);
        }
      })
    },*/
    //树形转换
    handleTree(data, id, parentId, children) {
      let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children'
      };

      var childrenListMap = {};
      var nodeIds = {};
      var tree = [];

      for (let d of data) {
        let parentId = d[config.parentId];
        if (childrenListMap[parentId] == null) {
          childrenListMap[parentId] = [];
        }
        nodeIds[d[config.id]] = d;
        childrenListMap[parentId].push(d);
      }

      for (let d of data) {
        let parentId = d[config.parentId];
        if (nodeIds[parentId] == null) {
          tree.push(d);
        }
      }

      for (let t of tree) {
        adaptToChildrenList(t);
      }

      function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
          o[config.childrenList] = childrenListMap[o[config.id]];
        }
        if (o[config.childrenList]) {
          for (let c of o[config.childrenList]) {
            adaptToChildrenList(c);
          }
        }
      }

      return tree;
    },
  }
}
</script>
<style scoped>
.titleName{
  height: 55px;
}
.spot {
  color: #008D40;
  padding: 0 5px;
  width: 20px;
  height: 20px;
  border-radius: 50px;
}
.newtitle:hover{
  color: #008D40;
}
.widthbox {
  height: 520px;
}

.newcontent {
  color: #989898;
  font-size: 14px;
  padding: 15px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.newtitle {
  font-weight: 600;
  cursor: pointer;
}
.flexbox{
  padding: 40px 0;
  width: 90%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-left: 190px;
}
.flexmIg{
  width: calc(100% / 3);
  text-align: center;
}
.flexImg img{
  width: 70%;
}
.newbox {
  padding: 19px 0;
}
.newtext{
  max-height:420px;
  overflow: auto;
  padding: 0 55px;
}
.newDetail {
  float: left;
  /*width: calc(100% - 50%);*/
  padding: 15px;
}

.borbox {
  width: 30%;
  border-left: solid 1px #CACACA;
}

.titbox {
  padding: 0 15px;
  cursor: pointer;
}

.active {
  border: solid 1px #008D40;
  background: #008D40;
  color: #fff;
  border-radius: 2px;
  font-weight: 600;
}

.tabbox div {
  border: solid 1px #CACACA;
  padding: 10px 15px;
  cursor: pointer;
  font-weight: 600;
  width: 15% !important;
  margin-bottom: 15px;
  text-align: center !important;
}

.news {
  border-left: solid 1px #CACACA;
  padding: 15px;
  font-weight: 600;
  width: 30%;

}

.new div {
  color: #009444;
}

.newtit {
  border-left: solid 5px #008D40;
  height: 43px;
  padding: 0px 10px;
  font-size: 20px;
}

.tabbox {
  width: 100%;
  display: flex;
  padding: 15px 0;
  justify-content: space-between;
  max-height: 220px;

}

.flexsbox {
  display: flex;
}

.more {
  color: #06A0F6;
  float: right;
  font-size: 16px;
  cursor: pointer;
}

.textbox {
  text-indent: 2em;
  line-height: 2.2;
}

.cenbox {
  text-align: center;
  padding: 15px;
  font-weight: 600;
}

.jsbox {
  width: 100%;
  display: flex;
  background-image: url("../../static/img/homeQyzx1.png");
  background-size: 100% 100%;
  height: 1270px;
  margin: 15px 0;
}
.dszbox{
  display: flex;
  background-image: url("../../static/img/dszjiyu.jpg");
  background-size: 100% 100%;
  height: 600px;
}
.introduce {
  background: #FFFFFF;
  padding: 15px;
  height: 350px;
  margin-top: 40px;
  border-radius: 15px;
  margin-left: -200px;
  width: 700px;
  z-index: 2;
}

.imgbox {
  margin: 15px 0 0px 40px;
  width: 60%;
  height: 400px;
  /*z-index:1;*/
  /*position: absolute;*/
  background-image: url("../../static/img/img.jpg");
  background-size: 100% 100%;
}

.lowerbox {
  background-color: #F5F5F5;
  padding: 25px;
  margin: 15px;
  margin-left: 3%;
  width: 90%;
}

.mlbox {
  border-left: solid 5px #008D40;
  padding: 0px 10px;
  font-size: 20px;
  font-weight: 600;
}

.pctitle {
  font-size: 10px;
}

.cpb {
  padding: 15px 0;
  overflow: auto;
}


.cpbox1 {
  width: calc(100% / 6 - 30px) ;
  float: left;
  margin: 15px;
  cursor: pointer;
}
.cpsimg{
  text-align: center;
}
.cpimg {
  height: 220px;
  width: 200px;
  object-fit: cover;
}

.cpname {
  background-color: #F7F7F7;
  text-align: center;
}
.titleName{
  min-height: 45px;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;     /* 垂直居中 */
}
.detailbox{
  font-size: 14px;
  background-color: rgb(0, 140, 62);
  width: 110px;
  margin: 14px auto;
  border-radius: 5px;
  color: rgb(255, 255, 255);
  padding: 5px;
}
.xqbox {
  color: rgb(158, 159, 159);
  font-size: 12px;
}
@media screen and (max-width: 500px) {
  .cpbox1 {
    width: calc(100% / 2 - 30px) ;
    float: left;
    margin: 15px;
    cursor: pointer;
  }
  .newsbigbox{
    width: 100%  !important;
  }
  .newsboxs{
    display: block;
  }
  .newbox2{
    width: 100%;
    padding: 0px;
  }
  .widthbox{
    height: 100%;
  }
  .flexsbox{
    display: block!important;
    overflow: hidden !important;
  }
  .newtext{
    overflow: auto;
    max-height: 320px;
    padding: 15px;
  }
  .flexbox{
    margin-left: 0px;
    padding: 0;
    display: block;
    width: 90% !important;
    margin: auto;
  }
  .flexbox div{
    margin-bottom: 15px;
  }
  .flexImg img{
    width: 100% !important;
  }
  .phoneImg{
    display: block;
  }
  .tabbox {
    width: calc(100% - 5px);
    padding: 30px 0;
    justify-content: flex-start;
    margin-left: 0px;
}
  .active{
    /*padding: 5px;*/
  }
  .tabbox div {
    padding: 3px 15px;
    cursor: pointer;
    font-weight: 600;
    width: 33% !important;
  }
  .introduce{
    background: #FFFFFF;
    padding: 15px;
    height: 350px;
    margin-top: -122px;
    border-radius: 15px;
    margin-left: 0px;
    width: 330px;}
  .imgbox {
    margin: 15px 0 90px 15px;
    width: 95%;
    height: 150px;
    border-radius: 15px;
    /*z-index:1;*/
    /*position: absolute;*/
    background-image: url("../../static/img/img.jpg");
    background-size: 100% 100%;
  }
  .jsbox{
    display:block;
    background-image: url("../../static/img/homeQyzx2.jpg");
  }
  .dszbox{
    width: 100%;
    background-image: url("../../static/img/homeDsz2.jpg");
  }
}
</style>
